import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';
import './Games.css';
import arrow from '../images/redcoris-arrow.svg';
import echoesHero from '../images/library_hero_english.png';
// import projectVoidImg from '../images/project_void.png';

const Games = () => {
    const sectionRef = useRef(null);
    const [selectedTrailer, setSelectedTrailer] = useState(null);

    const openTrailer = (url) => {
        setSelectedTrailer(url);
        document.body.style.overflow = 'hidden';
    };

    const closeTrailer = () => {
        setSelectedTrailer(null);
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        const elements = sectionRef.current.querySelectorAll('.hidden-element');
        elements.forEach((el) => observer.observe(el));

        const currentSection = sectionRef.current;

        return () => {
            if (currentSection) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                const elements = currentSection.querySelectorAll('.hidden-element');
                elements.forEach((el) => observer.unobserve(el));
            }
        };
    }, []);

    const games = [
        {
            id: 1,
            title: "Echoes of Sin: Confusion (released)",
            description: "A psychological horror game with a focus on sound and atmosphere.",
            image: echoesHero,
            link: "https://echoes.redcoris.com/",
            steamLink: "https://store.steampowered.com/app/4426280/Echoes_of_Sin_Confusion/",
            tags: ["Windows", "Linux", "Horror"],
            trailerUrl: "https://www.youtube.com/embed/3AVl_6ODA0A?autoplay=1"
        },
        /* {
             id: 2,
             title: "Farm Ranch",
             description: "Lowpoly coop farming game.",
             image: "https://placehold.co/600x400/1a1a1a/ffffff?text=Farm",
             link: "#",
             steamLink: "#",
             tags: ["Windows", "Linux", "Simulator"]
         },*/
    ];

    return (
        <section className="games-section" id="games" ref={sectionRef}>
            <div className="section-header hidden-element">
                <img src={arrow} alt="arrow" className="section-arrow" />
                <h2><span className="brand-red">RED</span>Coris — <span className="section-title-white">Games</span></h2>
            </div>

            <div className="games-grid">
                {games.map((game, index) => (
                    <div key={game.id} className="game-card hidden-element" style={{ transitionDelay: `${index * 200}ms` }}>
                        <div className="game-image-container">
                            <img src={game.image} alt={game.title} className="game-image" />
                            <div className="play-trailer-overlay">
                                <button
                                    className="play-trailer-btn"
                                    onClick={() => openTrailer(game.trailerUrl)}
                                >
                                    <span className="play-icon">▶</span> Watch Trailer
                                </button>
                            </div>
                        </div>
                        <div className="game-content">
                            <h3>{game.title}</h3>
                            <div className="game-tags">
                                {game.tags.map((tag, i) => (
                                    <span key={i} className="game-tag">{tag}</span>
                                ))}
                            </div>
                            <p>{game.description}</p>
                            <div className="game-actions">
                                <a href={game.link} className="game-link">Learn More</a>
                                <a href={game.steamLink} className="steam-link">
                                    <i className="fab fa-steam"></i> Buy on Steam
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <AnimatePresence>
                {selectedTrailer && (
                    <motion.div
                        className="video-modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeTrailer}
                    >
                        <motion.div
                            className="video-modal-content"
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button className="modal-close-btn" onClick={closeTrailer}>
                                <IoClose />
                            </button>
                            <div className="modal-video-wrapper">
                                <iframe
                                    src={selectedTrailer}
                                    title="Game Trailer"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};

export default Games;
